export const uniqueArray = (arr: any[]) => {
  const ret = [];
  for (let i = 0, size = arr.length; i < size; i++) {
    if (ret.indexOf(arr[i]) === -1 && arr[i] !== '') {
      ret.push(arr[i]);
    }
  }
  return ret;
}